import { render, staticRenderFns } from "./LookupProductPrefix.vue?vue&type=template&id=1ffb725b&scoped=true"
import script from "./LookupProductPrefix.vue?vue&type=script&lang=ts"
export * from "./LookupProductPrefix.vue?vue&type=script&lang=ts"
import style0 from "./LookupProductPrefix.vue?vue&type=style&index=0&id=1ffb725b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffb725b",
  null
  
)

export default component.exports